<template>
  <div id="privacy">
    <div class="row mt-md-5">
      <div class="col-md-12 title">
        <p>プライバシーポリシー</p>
      </div>
      <div class="col-md-12">
        <p>アイルクリエイティブ株式会社（以下「当社」といいます。）は当サイト上で収集した個人情報を適切に保護し、取り扱いいたします。</p>
      </div>
      <div class="col-md-12">
        <p>個人情報とは</p>
        <p>このプライバシーポリシーに述べられている「個人情報」とは、個人に関する情報のうち、氏名、住所、電子メールアドレスなどの当該個人を特定することができる情報を言います。</p>
      </div>
      <div class="col-md-12">
        <p>個人情報の利用目的について</p>
        <p>当社が個人情報を利用する目的は、以下のとおりです。</p>
        <p>1 おひさまキッチンの絵本に関する、発売情報、イベント、サービスのご案内</p>
        <p>2 当社が提供する、サービス、イベントのご案内</p>
      </div>
      <div class="col-md-12">
        <p>個人情報の第三者提供について</p>
        <p>当社は、個人情報保護法その他法令で許容されている場合等正当な理由がある場合を除き、個人情報を事前にご本人の承諾を得ることなく第三者に提供いたしません。</p>
      </div>
      <div class="col-md-12">
        <p>安全管理措置</p>
        <p>当社の保有する個人情報への不正アクセスや、個人情報の紛失、破壊、改ざん、漏洩が起こらないよう、個人情報を管理する責任者を置き、適切な管理を行います。</p>
      </div>
      <div class="col-md-12">
        <p>開示の求め・対応</p>
        <p>当社は、ご本人が自らの個人情報の開示、訂正、情報やサービスの紹介の停止、または消去など希望される場合、ご本人であることを確認したうえで、法令の規定に基づき、すみやかに対応します。</p>
      </div>
      <div class="col-md-12">
        <p>プライバシーポリシーの変更について</p>
        <p>当社は、このプライバシーポリシーの内容を、事前の予告なく変更することがあります。</p>
      </div>
      <div class="col-md-12">
        <p>問い合わせ先</p>
        <p>〒150-0022 東京都渋谷区恵比寿南 1-20-2 シェモア恵比寿 3F</p>
        <p><a href="mailto:ayrcreative@gmail.com">ayrcreative@gmail.com</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: "プライバシーポリシー",
    data() {
      return {}
    },
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue